import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()

  const postHeaders = { "Content-Type": "application/json" }

  const fetchConsultNotes = async (eventId) => {
    return apiWrapper({
      fetch,
      url: `events/event/consultNotes?eventId=${eventId}`,
      options: {
        method: 'GET'
      }
    });
  }

  const uploadConsultNotes = async (eventId, files) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    formData.append('eventId', eventId);

    return apiWrapper({
      fetch,
      url: `file/upload/consultNotes`,
      options: {
        method: 'POST',
        body: formData
      }
    });
  }

  const deleteConsultNote = async (eventId, fileName) => {
    return apiWrapper({
      fetch,
      url: `file/delete/consultNotes`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ eventId, fileName })
      }
    });
  }

  return {
    fetchConsultNotes,
    uploadConsultNotes,
    deleteConsultNote
  }
}